import React from 'react';

import { DotIcon } from '@vlabs/icons';
import { SideMenu, Badge } from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Popover } from '@vlabs/shared/components/popover/Popover';

import st from './CustomFilterPopover.module.sass';

export function CustomFilterPopover({
  triggerValue = '',
  children = undefined,
  filterCount = 0, // показываем бадж с цифрой при наличии значений в фильтре
  hasFilterValue = false, // показываем точку при наличии значения в фильтре
  hasError = false,
  leftIcon = undefined,
  testId = undefined,
  triggerNode = null,
  ...props
}) {
  // по дефолту триггер для поповера - это MenuItem/DotIcon
  // но можно передать в triggerNode любой свой компонент/элемент
  const isDisabled = props?.disabled;
  const finalTrigger = triggerNode ?? (
  <SideMenu.MenuItem
    data-testid={`MenuItem.${testId}`}
    disabled={isDisabled}
    leftIcon={leftIcon}
    rightIcon={(filterCount > 0 && <Badge value={filterCount} />)
          || (hasFilterValue && (
            <DotIcon
              className={cn({
                [st.DotIconPrimary]: hasFilterValue,
                [st.DotIconNegative]: hasError,
              })}
            />
          ))}
    value={triggerValue}
  />
  );

  return (
    <Popover
      hasError={hasError}
      portalTarget={document.body}
      trigger={finalTrigger}
      {...props}
    >
      {children}
    </Popover>
  );
}

CustomFilterPopover.propTypes = {
  triggerNode: PropTypes.node,
  leftIcon: PropTypes.node,
  children: PropTypes.node,
  triggerValue: PropTypes.string,
  testId: PropTypes.string,
  filterCount: PropTypes.number,
  hasFilterValue: PropTypes.bool,
  hasError: PropTypes.bool,
};
